import React from "react";


const OurIdentitySection = () => {
  return (
    <section className="w-full bg-white">
      <div
        className="
          mx-auto w-full max-w-7xl
          px-4 sm:px-6 lg:px-8
          py-10 sm:py-14 lg:py-16
        "
      >
        <div
          className="
            grid items-center gap-10 lg:gap-14
            lg:grid-cols-2
          "
        >
          {/* Left: Content */}
          <div className="text-center lg:text-left">
            <h2
              className="
                text-[#0b4f6c]
                font-bold tracking-tight
                text-[clamp(1.6rem,3.2vw,2.4rem)]
                leading-[1.15]
              "
            >
              Our Identity
            </h2>

            <p
              className="
                mt-4 sm:mt-5
                text-slate-600
                text-[clamp(0.95rem,1.1vw,1.05rem)]
                leading-7 sm:leading-8
                max-w-2xl mx-auto lg:mx-0
              "
            >
              Digital Transformation Associates is a fast-growing consulting
              firm focused on delivering advanced Supply Chain consulting
              services and technology solutions. We bring deep expertise across
              a wide range of platforms and tools, including SAP solutions (IBP,
              APO, MM, PP, EWM, TM, MDM/MDG, CRM/TPM, and S/4HANA), Cloud and
              DevOps, Data Engineering, Big Data and Analytics, as well as
              modern application development using Java, JavaScript, Angular,
              React, and UI/UX design. Our capabilities also extend to Machine
              Learning, Generative AI, Sustainability Modeling, and other
              emerging technologies that strengthen and support our end-to-end
              Supply Chain consulting offerings.
            </p>

            <div className="mt-7 sm:mt-9 flex justify-center lg:justify-start">
              <a
                href="/about"
                className="
                  inline-flex items-center justify-center
                  rounded-md
                  bg-[#0b4f6c] text-white
                  px-6 py-3
                  text-sm font-semibold
                  shadow-sm
                  transition
                  hover:bg-[#083f56]
                  focus:outline-none focus:ring-2 focus:ring-[#0b4f6c]/40
                  focus:ring-offset-2
                "
              >
                About Us
              </a>
            </div>
          </div>

          {/* Right: Image */}
          <div className="flex justify-center lg:justify-end">
            <div
              className="
                w-full max-w-xl
                overflow-hidden rounded-2xl
                bg-slate-100
                shadow-sm ring-1 ring-black/5
              "
            >
              <img
                src="/assets/our-identity.webp"
                alt="Team collaborating around devices"
                className="
                  h-full w-full object-cover
                  aspect-[16/10] sm:aspect-[16/9]
                "
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurIdentitySection;
